import { apiAction, API_SUCCESS } from "../dux/api";
import { FETCH_MY_BOOKINGS, setMyBookings } from "../dux/myBookings";
import { parseMyBookings } from "../helpers/myBookingsHelper";
import { getUserBookingsUrl } from "../helpers/apiEndPoints";

const myBookings = () => (next) => (action) => {
  next(action);

  if (action.type === FETCH_MY_BOOKINGS) {
    next(
      apiAction({
        url: getUserBookingsUrl(),
        feature: FETCH_MY_BOOKINGS,
      })
    );
  }

  if (action.type === `${FETCH_MY_BOOKINGS} ${API_SUCCESS}`) {
    // The API middleware dispatches apiSuccess with { response: axiosResponse.data, feature, meta }
    // But the actual payload structure is the response data directly
    const bookings = action.payload || [];
    const parsedData = parseMyBookings(bookings);
    next(setMyBookings({ list: parsedData }));
  }
};

export default myBookings;
